import { useAppHooks } from "./useAppHooks";

const AppHookComponent = () => {
  useAppHooks();
  return null;
};

export default AppHookComponent;
